export default __webpack_public_path__ + "static/media/Anjelica_tmb.79ce2a34.jpg";